import {
	type FrontendPlacementMessage,
	type AnyFrontendStage,
} from '@post-office/message-maker-browser/types';

import ChartBarLineIcon from '@atlaskit/icon-lab/core/chart-bar-line';

import { HandleActionType } from '@atlassian/rovo-conversation-actions/types';

import { useCallback, useMemo } from 'react';

import { PlacementFrontend } from '@post-office/browser--post-office-team/rovo-nudge';

import { NudgeDefinition } from '@post-office/browser--post-office-team/rovo-nudge/nudge-definition';

import { assertMessageTemplateContext } from '../../../__generated__/validation/messageTemplateContext';

import { type MessageTemplateContext } from '../../../index';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: AnyFrontendStage;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: assertMessageTemplateContext,
		Component: ({ title, description }: MessageTemplateContext) => {
			const icon = useCallback(() => <ChartBarLineIcon size="medium" label={title} />, [title]);
			const nudgeContext = useMemo(() => ({ id: 'live-nudge-demo-message' }), []);

			return (
				<NudgeDefinition
					title={title}
					description={description}
					icon={icon}
					handleType={HandleActionType.Chat}
					staticPrompt={`Tell me more about: ${title}`}
					starterType="static"
					nudgeContext={nudgeContext}
				/>
			);
		},
	},
});
